// eslint-disable-next-line import/no-anonymous-default-export
export default ['ImageOnly', 'FreeProducts', 'ColorSelector', 'Default', 'Lumigen'];
